
export default {
  props: {
    dialog: { type: Boolean, default: false },
    message: { type: String, default: "Cargando..." },
    progress: { type: Number, default: null }
  }
};
